module.exports = __webpack_public_path__ + "static/img/inkdrops.6430246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inkdrops.png
// module id = K1j8
// module chunks = 1